var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"visible":_vm.visible,"title":"Note Detail","ok-only":""},on:{"hidden":_vm.closeModal}},[_c('p',{staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.note))])])
}
var staticRenderFns = []

export { render, staticRenderFns }